module.exports = __webpack_public_path__ + "img/pr-3.ec638137.png";